import React, { FC } from 'react';
import { KiteIcon } from '@kite/react-kite';
import { SmartLink } from '../SmartLink/SmartLink';
import { ImageDataLike } from 'gatsby-plugin-image';
import { SectionVideoCardVideo } from './SectionVideoCardVideo';
import './SectionVideoCard.scss';

interface ISectionVideoCard {
    description: string;
    eyebrow: string;
    title: string;
    link?: {
        title: string;
        uri: string;
    };
    mediaLibVideoURL?: string;
    posterImg?: {
        localFile: ImageDataLike;
        alt: string;
    };
    youtubeVideoURL?: string;
}
export const SectionVideoCard: FC<{ inputs: ISectionVideoCard }> = ({
    inputs,
}) => {
    const hasLink = inputs.link?.uri && inputs.link.uri !== `route:<nolink>`;

    return (
        <>
            <div className="section-video-card">
                <div className="section-video-card__video-wrapper">
                    <SectionVideoCardVideo
                        title={inputs.title}
                        posterImg={inputs.posterImg}
                        videoSrc={
                            inputs.mediaLibVideoURL || inputs.youtubeVideoURL
                        }
                    />
                </div>
                <div className="section-video-card__text-content">
                    {inputs.eyebrow && (
                        <p className="section-video-card__eyebrow">
                            {inputs.eyebrow}
                        </p>
                    )}
                    <h3 className="section-video-card__title">
                        {inputs.title}
                    </h3>
                    <p className="section-video-card__description">
                        {inputs.description}
                    </p>
                    {hasLink && (
                        <SmartLink
                            url={inputs.link.uri}
                            classNames={[`section-video-card__link`]}
                            newWindow
                        >
                            {inputs.link.title || `View More`}
                            <KiteIcon icon="ki-arrow-right" size="1rem" />
                        </SmartLink>
                    )}
                </div>
            </div>
        </>
    );
};
